export const TrailerFormAction = {
  EDIT: 'edit',
  ARRIVE: 'arrive',
};

export type TrailerFormAction = (typeof TrailerFormAction)[keyof typeof TrailerFormAction];
